import {get} from 'lodash'
const initialState = {
  familyTableDetails: [],
  notices: [],
  getState: 0,
  readState: 0,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    // case "GET_FAMILY_DIR_TABLE_DETAILS_FULFILLED":
      // console.log(action.payload.data)
      // const familyTableDetail = action.payload.data;
      // return { ...state, getState: 2, familyTableDetails: get(familyTableDetail[0], 'data') };
    case "GET_FAMILY_DIR_TABLE_DETAILS_REJECTED":
      return { ...state, getState: 3 };
    case "GET_FAMILY_DIR_TABLE_DETAILS_PENDING":
      return { ...state, getState: 1 };
    case "SEARCH_FAMILY_DIR_TABLE_DETAILS_FULFILLED":
      const familyTableDetail = action.payload.data;
      return { ...state, getState: 2, familyTableDetails: action.payload.data};
    case "SEARCH_FAMILY_DIR_TABLE_DETAILS_REJECTED":
      return { ...state, getState: 3 };
    case "SEARCH_FAMILY_DIR_TABLE_DETAILS_PENDING":
      return { ...state, getState: 1 };

    case "GET_ALL_NOTICES_FULFILLED":
      return { ...state, getState: 2, notices: action.payload.data };
    case "GET_ALL_NOTICES_REJECTED":
      return { ...state, getState: 3 };
    case "GET_ALL_NOTICES_PENDING":
      return { ...state, getState: 1 };
    default:
      return state;
  }
};

export default reducer;
